export default [
  {
    path: '/real-estate-developments-settings',
    name: 'RealEstateDevelopmentsSettingsList',
    component: () => import('pages/real-estate-developments-settings/RealEstateDevelopmentsSettingsList.vue')
  }
]
